const INIT_STATE = {};


export default function (state = INIT_STATE, action) {
  const { type, payload } = action;

  const id = ( payload || {} ).id || null;

  switch(type) {
    case 'FETCH_DROPDOWN_LIST_INPROGRESS': {
      return {
        ...state,
        [id]: dropdownReducer(state[id], action)
      }
    }

    case 'FETCH_DROPDOWN_LIST_DONE': {
      return {
        ...state,
        [id]: dropdownReducer(state[id], action)
      }
    }

    case 'FETCH_DROPDOWN_LIST_ERROR': {
      return {
        ...state,
        [id]: dropdownReducer(state[id], action)
      }
    }

    default: {
      return state;
    }
  }
}


const DROPDOWN_INIT_STATE = {
  isFetching: false,
  list: [],
  searchTerm: '',
  error: null
}


function dropdownReducer(state = DROPDOWN_INIT_STATE, action) {
  switch (action.type) {
    case 'FETCH_DROPDOWN_LIST_INPROGRESS': {
      return {
        ...DROPDOWN_INIT_STATE,
        isFetching: true,
        list: state.list
      }
    }

    case 'FETCH_DROPDOWN_LIST_DONE': {
      const { payload: { list, searchTerm } } = action;
      return {
        ...DROPDOWN_INIT_STATE,
        list: list,
        searchTerm: searchTerm
      }
    }

    case 'FETCH_DROPDOWN_LIST_ERROR': {
      const { payload: { error } } = action;
      return {
        ...DROPDOWN_INIT_STATE,
        error: error
      }
    }

    default: {
      return state;
    }
  }
}